// components/providers/DataProviders.tsx
import React, { ReactNode } from 'react';
import { AppApolloProvider } from '../hooks/useApolloClient';
import { AnalyticsProvider, AWSKeysProvider } from '@hooks';

import { ActivityProvider } from '../hooks/useActivity';
import { UserSettingsProvider } from '../hooks/useUserSettings';
import { SendToAirtableProvider } from '@src/components/send-to-airtable-provider';

interface DataProvidersProps {
  children: ReactNode;
}

export const DataProviders: React.FC<DataProvidersProps> = ({ children }) => {
  return (
    <AppApolloProvider>
      <AnalyticsProvider>
        <SendToAirtableProvider>
          <AWSKeysProvider>
            <UserSettingsProvider>
              <ActivityProvider>
                {children}
              </ActivityProvider>
            </UserSettingsProvider>
          </AWSKeysProvider>
        </SendToAirtableProvider>
      </AnalyticsProvider>
    </AppApolloProvider>
  );
};